import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/added",
  "use": "app/added-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"app/added\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 24c0 13.231 10.764 24 24 24 13.231 0 24-10.764 24-24S37.236 0 24 0 0 10.768 0 24zm2.737 0C2.737 12.274 12.274 2.737 24 2.737S45.263 12.274 45.263 24 35.726 45.263 24 45.263 2.737 35.726 2.737 24zm11.279.524l7.462 7.462L35 18.463l-1.934-1.934-11.59 11.585-5.527-5.528-1.934 1.939z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol